import React from 'react';
import './PaymentMethodModal.css';

interface PaymentMethodModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectMethod: (method: 'payfast' | 'debit_order') => void;
  amount: number;
}

// SVG Icons
const CardIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);

const CalendarIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
    <path d="M9 16l2 2 4-4" />
  </svg>
);

const ArrowIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const PaymentMethodModal: React.FC<PaymentMethodModalProps> = ({ isOpen, onClose, onSelectMethod, amount }) => {
  if (!isOpen) return null;

  return (
    <div className="payment-modal-overlay" onClick={onClose}>
      <div className="payment-modal-content" onClick={e => e.stopPropagation()}>
        <div className="payment-modal-header">
          <h3>Choose Payment Method</h3>
          <button className="close-btn" onClick={onClose} aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        
        <div className="payment-amount-display">
          <span className="label">Amount to Pay</span>
          <span className="amount">
            {new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR' }).format(amount)}
          </span>
        </div>

        <div className="payment-options">
          {/* PayFast Option */}
          <button 
            className="payment-option-card"
            onClick={() => onSelectMethod('payfast')}
          >
            <div className="option-icon payfast-icon">
              <CardIcon />
            </div>
            <div className="option-details">
              <span className="option-title">PayFast</span>
              <span className="option-desc">Pay with card or instant EFT</span>
              <span className="option-fee">Fee: ~2.5%</span>
            </div>
            <div className="option-arrow">
              <ArrowIcon />
            </div>
          </button>

          {/* Debit Order Option */}
          <button 
            className="payment-option-card"
            onClick={() => onSelectMethod('debit_order')}
          >
            <div className="option-icon debit-icon">
              <CalendarIcon />
            </div>
            <div className="option-details">
              <span className="option-title">Debit order (DebiCheck)</span>
              <span className="option-desc">
                Set up monthly auto-debit via NuPay (bank approval required)
              </span>
              <span className="option-fee">No fees</span>
            </div>
            <div className="option-arrow">
              <ArrowIcon />
            </div>
          </button>
        </div>

        <div className="payment-security-note">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
          <span>All payments are secured with bank-level encryption</span>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodModal;
